<template>
  <!-- 菜单权限管理 -->
  <div class="paddbox autobox">
    <div>
      <el-card class="page-card" shadow="never">
        <!-- 筛选区 -->
        <div class="filter-bar">
          <!-- 媒体账户 -->
          <div class="filter-item filter-account">
            <span class="filter-label">媒体账户</span>
            <div class="filter-account-box" @click="mediaAccountView = true">
              <template v-if="config.mediaAccountList.length > 0">
                <el-tooltip :content="mediaAccountNames" placement="top" :show-after="200">
                  <span class="filter-account-text">{{ mediaAccountNames }}</span>
                </el-tooltip>
                <el-tag size="small" type="primary" round>{{ config.mediaAccountList.length }} 个</el-tag>
              </template>
              <span v-else class="filter-empty">点击选择媒体账户</span>
              <el-icon class="filter-account-icon">
                <ArrowRight />
              </el-icon>
            </div>
          </div>
          <!-- 项目名称 -->
          <div class="filter-item filter-account">
            <span class="filter-label">项目名称</span>
            <div class="filter-account-box" @click="projectNameView = true">
              <template v-if="config.projectNameList.length > 0">
                <el-tooltip :content="projectNameNames" placement="top" :show-after="200">
                  <span class="filter-account-text">{{ projectNameNames }}</span>
                </el-tooltip>
                <el-tag size="small" type="primary" round>{{ config.projectNameList.length }} 个</el-tag>
              </template>
              <span v-else class="filter-empty">点击输入项目名称</span>
              <el-icon class="filter-account-icon">
                <ArrowRight />
              </el-icon>
            </div>
          </div>
          <!-- 项目状态 -->
          <div class="filter-item">
            <span class="filter-label">项目状态</span>
            <el-select v-model="config.statusFirst" size="small" placeholder="请选择项目状态" clearable class="filter-control"
              style="width: 140px" @clear="config.statusFirst = ''">
              <el-option v-for="item in statusFilterOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
          <div class="filter-actions">
            <el-button type="primary" @click="projectSearchFun()" size="small">查询</el-button>
            <el-button size="small" @click="projectResetFun()">重置</el-button>
          </div>
        </div>

        <el-divider style="margin: 4px 0 16px"></el-divider>
        <!-- 批量追加素材 -->
        <div class="table-toolbar">
          <div class="toolbar-left">
            <el-button type="primary" :disabled="selectedProjects.length === 0" size="small"
              @click="openBatchAddDialog()">批量追加素材</el-button>
            <el-button size="small" @click="openAddTaskDialog()">查询追加任务</el-button>
            <!-- <el-button size="small" @click="openAddLogDialog()">查看追加日志</el-button> -->
            <span v-if="selectedProjects.length > 0" class="select-tip">已选 {{ selectedProjects.length }} 项</span>
          </div>
          <div class="toolbar-right">
            <el-button size="small" :loading="syncLoading" :disabled="syncLoading"
              @click="fullSyncFun()">同步项目到本地</el-button>
          </div>
        </div>
        <!-- table部分 -->
        <div>
          <el-table ref="projectTableRef" :data="projectList" v-loading="searchLoading" row-key="projectId"
            @selection-change="onProjectSelectionChange" @row-click="onProjectRowClick" border stripe
            style="width: 100%">
            <el-table-column type="selection" width="55" :reserve-selection="false" />
            <el-table-column prop="projectName" label="项目名称" min-width="220">
              <template #default="{ row }">
                <el-tooltip v-if="row.projectName" placement="top" effect="dark" :show-after="200" :hide-after="0">
                  <template #content>
                    <div
                      style="max-width: 480px; white-space: pre-wrap; word-break: break-all; max-height: 300px; overflow: auto;">
                      {{
                        row.projectName }}</div>
                  </template>
                  <div class="product-name cell-ellipsis">{{ row.projectName }}</div>
                </el-tooltip>
                <div v-else class="product-name">-</div>
                <div class="product-id">项目id：{{ row.projectId }}</div>
              </template>
            </el-table-column>
            <el-table-column prop="budget" label="项目预算" width="120" />
            <el-table-column prop="statusFirst" label="项目状态" width="170">
              <template #default="{ row }">
                <el-result :icon="statusFirstMeta(row.statusFirst).icon" :title="statusFirstMeta(row.statusFirst).label"
                  class="status-result status-mini" />
              </template>
            </el-table-column>
            <el-table-column prop="advertiserId" label="账户id" width="180" show-overflow-tooltip />
            <el-table-column label="商品名称" min-width="220">
              <template #default="{ row }">
                <div class="product-name">{{ row.productName }}</div>
                <div class="product-id">商品id：{{ row.productId }}</div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div style="margin-top: 12px; display: flex; justify-content: center">
          <paginationMax50 :pagesize="pagesize" :pagesizes="pagesizeOptions" :currentPage="currentPage" :total="total"
            @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" />
        </div>

      </el-card>
    </div>

    <div>
      <!-- 选择媒体账户弹窗（借鉴 ylyProjectManage.vue） -->
      <el-dialog v-model="mediaAccountView" title="选择媒体账户" width="40%">
        <insertViewBatchTrim @getDataListFun="getSonAccountListFun" :datas="config.accountIds"
          :descParam="config.accountIdsDesc" @getCannelFun="mediaAccountView = false"></insertViewBatchTrim>
      </el-dialog>

      <!-- 输入项目名称弹窗：textarea换行一行一个 -->
      <el-dialog v-model="projectNameView" title="输入项目名称" width="40%" @open="onProjectNameOpen()">
        <div style="margin-bottom: 8px; font-size: 13px; color: #909399;">每行一个项目名称，最多30条（超出自动截取前30条）{{projectNameText ?
          `，当前有效 ${projectNameText.split('\n').map(i => i.trim()).filter(i => !!i).length} 条` : ''}}</div>
        <el-input v-model="projectNameText" type="textarea" :rows="10" placeholder="每行一个项目名称" clearable />
        <template #footer>
          <el-button @click="projectNameView = false">取消</el-button>
          <el-button type="primary" @click="confirmProjectNameFun()">确定</el-button>
        </template>
      </el-dialog>

      <!-- 批量追加素材弹窗 -->
      <el-dialog v-model="batchAddView" title="批量追加素材" width="80%">
        <div class="batch-add-toolbar">
          <div class="batch-add-toolbar-left">
            <el-radio-group v-model="videoHpVisibility" size="medium">
              <el-radio-button label="HIDE_VIDEO_ON_HP">仅单次展示可见</el-radio-button>
              <el-radio-button label="ALWAYS_VISIBLE">主页始终可见</el-radio-button>
            </el-radio-group>
            <span v-if="autoMatchTip" class="auto-match-tip" :class="`auto-match-tip--${autoMatchTipType}`">{{
              autoMatchTip
              }}</span>
          </div>
          <div class="batch-add-toolbar-right">
            <span class="auto-match-warn">素材自动匹配前{{ maxCount }}条组织素材；自动匹配轮询时，请勿关闭弹窗。</span>
            <el-button type="primary" plain size="small" :loading="autoMatchLoading" :disabled="autoMatchLoading"
              @click="openAutoMatchCountDialog()">自动匹配素材</el-button>
          </div>
        </div>
        <div class="batch-product-list">
          <div v-for="item in selectProductData" :key="item.productId" class="batch-product-card">
            <div class="batch-product-head">
              <span class="batch-product-name">{{ item.productName || '未知商品' }}，剧目ID：{{ item.productId }}</span>
              <el-tag v-if="!(item.videos || []).length" size="small" type="warning">未选择素材，将跳过</el-tag>
              <span class="batch-product-count">{{ (item.videos || []).length }}个素材</span>
              <el-button type="primary" size="small" @click="openSucaiSelectorFun(item)">选择素材</el-button>
              <el-button type="danger" size="small" @click="clearProductVideosFun(item)">清空素材</el-button>
            </div>
            <div v-if="(item.videos || []).length > 0" class="batch-product-thumbs">
              <div class="batch-thumb-wrap" :class="{ collapsed: !item._expanded }">
                <div v-for="v in (item.videos || [])" :key="v.materialId || v.videoId" class="batch-thumb">
                  <img :src="v.posterUrl" :title="v.materialName" />
                  <span class="batch-thumb-name" :title="v.materialName">{{ v.materialName }}</span>
                </div>
              </div>
              <div v-if="(item.videos || []).length > 8" class="batch-thumb-toggle">
                <el-button type="text" size="small" @click="item._expanded = !item._expanded">
                  {{ item._expanded ? '收起' : `展开全部（${(item.videos || []).length}）` }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <template #footer>
          <el-button @click="batchAddView = false">取消</el-button>
          <el-button type="primary" @click="confirmBatchAddFun()">确定追加</el-button>
        </template>
      </el-dialog>

      <!-- 选择素材弹窗 -->
      <el-dialog v-model="sucaiSelectView" title="选择素材" width="70%" append-to-body destroy-on-close>
        <ylySucaiSelector v-if="sucaiSelectView" :advertiserId="currentProduct.advertiserId"
          :defaultMaterialName="currentProduct.productName" :checkedList="currentProduct.videos"
          @confirm="confirmSucaiSelectFun" @cancel="sucaiSelectView = false" />
      </el-dialog>

      <!-- 自动匹配素材数量弹窗 -->
      <el-dialog v-model="autoMatchCountView" title="自动匹配素材" width="420px" append-to-body>
        <div class="auto-match-count-row">
          <span class="auto-match-count-label">素材匹配数量</span>
          <el-input-number v-model="maxCount" :min="1" :max="200" :step="1" step-strictly
            placeholder="请输入素材匹配数量" style="width: 180px" />
          <span class="auto-match-count-unit">条</span>
        </div>
        <div class="auto-match-count-tip">每个商品取素材库前 {{ maxCount || 0 }} 条组织素材进行匹配，最大 200 条</div>
        <template #footer>
          <el-button size="small" @click="autoMatchCountView = false">取消</el-button>
          <el-button type="primary" size="small" @click="confirmAutoMatchCountFun()">确定匹配</el-button>
        </template>
      </el-dialog>

      <!-- 追加日志弹窗 -->
      <el-dialog v-model="addLogView" title="追加日志" width="90%" destroy-on-close>
        <!-- 筛选区 -->
        <div class="filter-bar">
          <div class="filter-item">
            <span class="filter-label">账户id</span>
            <el-input v-model="addLogFilter.advertiserId" size="small" placeholder="请输入账户id" clearable
              class="filter-control" />
          </div>
          <div class="filter-item">
            <span class="filter-label">项目id</span>
            <el-input v-model="addLogFilter.projectId" size="small" placeholder="请输入项目id" clearable
              class="filter-control" />
          </div>
          <div class="filter-item">
            <span class="filter-label">项目名称</span>
            <el-input v-model="addLogFilter.projectName" size="small" placeholder="请输入项目名称" clearable
              class="filter-control" />
          </div>
          <div class="filter-item">
            <span class="filter-label">状态</span>
            <el-select v-model="addLogFilter.success" size="small" placeholder="全部" clearable class="filter-control">
              <el-option v-for="item in addLogSuccessOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">状态码</span>
            <el-input v-model="addLogFilter.code" size="small" placeholder="巨量接口返回码" clearable class="filter-control" />
          </div>
          <div class="filter-item">
            <span class="filter-label">创建时间</span>
            <el-date-picker v-model="addLogFilter.createTimeRange" type="daterange" size="small"
              start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" clearable
              class="filter-range" @change="onAddLogDateRangeChange" />
          </div>
          <div class="filter-item">
            <span class="filter-label">类型</span>
            <el-select v-model="addLogFilter.type" size="small" placeholder="全部" clearable class="filter-control"
              @clear="addLogFilter.type = undefined">
              <el-option v-for="item in addLogTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </div>
          <div class="filter-actions">
            <el-button type="primary" size="small" @click="addLogSearchFun()">查询</el-button>
            <el-button size="small" @click="resetAddLogFilterFun()">重置</el-button>
            <el-button type="warning" size="small" :loading="addLogRetryLoading" :disabled="addLogSelected.length === 0"
              @click="retryAddMaterialFun()">批量重提失败追投</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <el-table ref="addLogTableRef" :data="addLogList" v-loading="addLogLoading" border stripe
          style="width: 100%; margin-top: 12px" row-key="id" @selection-change="onAddLogSelectionChange">
          <el-table-column type="selection" width="55" :reserve-selection="false" />
          <el-table-column type="expand">
            <template #default="{ row }">
              <div class="log-expand">
                <!-- <div class="log-expand-row">
                  <span class="log-expand-label">请求videoIds：</span>
                  <span class="log-expand-value">{{ row.requestVideoIds || '-' }}</span>
                </div> -->
                <div class="log-expand-row">
                  <span class="log-expand-label">返回信息：</span>
                  <span class="log-expand-value">{{ row.message }}</span>
                </div>
                <div class="log-expand-row">
                  <span class="log-expand-label">失败videoIds：</span>
                  <span class="log-expand-value">{{ row.failedVideoIds || '-' }}</span>
                </div>
                <div class="log-expand-row">
                  <span class="log-expand-label">跳过videoIds：</span>
                  <span class="log-expand-value">{{ row.skippedVideoIds || '-' }}</span>
                </div>
                <div class="log-expand-row">
                  <span class="log-expand-label">requestIds：</span>
                  <span class="log-expand-value">{{ row.requestIds || '-' }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="advertiserId" label="账户id" width="160" show-overflow-tooltip />
          <el-table-column prop="projectId" label="项目id" width="180" show-overflow-tooltip />
          <el-table-column prop="projectName" label="项目名称" min-width="240">
            <template #default="{ row }">
              <el-tooltip v-if="row.projectName" placement="top" effect="dark" :show-after="200" :hide-after="0">
                <template #content>
                  <div
                    style="max-width: 480px; white-space: pre-wrap; word-break: break-all; max-height: 300px; overflow: auto;">
                    {{
                      row.projectName }}</div>
                </template>
                <div class="cell-ellipsis">{{ row.projectName }}</div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalVideos" label="视频素材总数" width="90" />
          <el-table-column prop="successCount" label="成功数" width="90" />
          <el-table-column prop="failCount" label="失败数" width="90" />
          <el-table-column prop="skippedCount" label="跳过数（已存在素材）" width="90" />
          <el-table-column prop="batchCount" label="批次数" width="90" />
          <el-table-column prop="success" label="状态" width="90">
            <template #default="{ row }">
              <el-tag v-if="row.success === 1" size="small" type="success">成功</el-tag>
              <el-tag v-else-if="row.success === 0" size="small" type="danger">失败</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="message" label="返回信息" min-width="220">
            <template #default="{ row }">
              <el-tooltip v-if="row.message" placement="top" effect="dark" :show-after="200" :hide-after="0">
                <template #content>
                  <div
                    style="max-width: 480px; white-space: pre-wrap; word-break: break-all; max-height: 300px; overflow: auto;">
                    {{
                      row.message }}</div>
                </template>
                <div class="cell-ellipsis">{{ row.message }}</div>
              </el-tooltip>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" show-overflow-tooltip />
        </el-table>
        <!-- 分页 -->
        <div style="margin-top: 12px; display: flex; justify-content: flex-end">
          <paginationMax50 :pagesize="addLogPage.pagesize" :currentPage="addLogPage.currentPage"
            :total="addLogPage.total" @handleCurrentChange="addLogPage.handleCurrentChange"
            @handleSizeChange="addLogPage.handleSizeChange" />
        </div>
        <template #footer>
          <el-button @click="addLogView = false">关闭</el-button>
        </template>
      </el-dialog>

      <!-- 追加任务弹窗 -->
      <el-dialog v-model="addTaskView" title="追加任务" width="80%" destroy-on-close>
        <!-- 筛选区 -->
        <div class="filter-bar">
          <div class="filter-item">
            <span class="filter-label">任务名称</span>
            <el-input v-model="addTaskFilter.taskName" size="small" placeholder="请输入任务名称" clearable
              class="filter-control" />
          </div>
          <div class="filter-item">
            <span class="filter-label">状态</span>
            <el-select v-model="addTaskFilter.status" size="small" placeholder="全部" clearable class="filter-control">
              <el-option v-for="item in addTaskStatusOptions" :key="item.value" :label="item.label"
                :value="item.value" />
            </el-select>
          </div>
          <div class="filter-item">
            <span class="filter-label">创建时间</span>
            <el-date-picker v-model="addTaskFilter.createTimeRange" type="daterange" size="small"
              start-placeholder="开始日期" end-placeholder="结束日期" format="YYYY-MM-DD" value-format="YYYY-MM-DD" clearable
              class="filter-range" @change="onAddTaskDateRangeChange" />
          </div>
          <div class="filter-actions">
            <el-button type="primary" size="small" @click="addTaskSearchFun()">查询</el-button>
            <el-button size="small" @click="resetAddTaskFilterFun()">重置</el-button>
          </div>
        </div>
        <!-- 表格 -->
        <el-table :data="addTaskList" v-loading="addTaskLoading" border stripe style="width: 100%; margin-top: 12px"
          row-key="id">
          <el-table-column prop="taskName" label="任务名称" min-width="240" show-overflow-tooltip />
          <el-table-column prop="batchGroupId" label="批次组ID" min-width="200" show-overflow-tooltip />
          <el-table-column prop="status" label="状态" width="100">
            <template #default="{ row }">
              <el-tag v-if="row.status === 'SUCCESS'" size="small" type="success">成功</el-tag>
              <el-tag v-else-if="row.status === 'FAIL'" size="small" type="danger">失败</el-tag>
              <el-tag v-else-if="row.status === 'RUNNING'" size="small" type="warning">执行中</el-tag>
              <el-tag v-else-if="row.status === 'PENDING'" size="small" type="info">待执行</el-tag>
              <span v-else>{{ row.status || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="totalCount" label="项目总数" width="80" />

          <el-table-column label="素材状态" min-width="220">
            <template #default="{ row }">
              <span style="color: #67c23a; font-weight: 600;">成功 {{ row.successCount ?? '-' }}</span>
              <span style="margin: 0 6px; color: #dcdfe6;">|</span>
              <span style="color: #f56c6c; font-weight: 600;">失败 {{ row.failCount ?? '-' }}</span>
              <span style="margin: 0 6px; color: #dcdfe6;">|</span>
              <span style="color: #e6a23c; font-weight: 600;">跳过 {{ row.skippedCount ?? '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90">
            <template #default="{ row }">
              <el-button type="text" link size="small" @click="openTaskLogDetailFun(row)">详情</el-button>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" width="170" show-overflow-tooltip />
          <el-table-column prop="updateTime" label="更新时间" width="170" show-overflow-tooltip />

        </el-table>
        <!-- 分页（最大50条/页） -->
        <div style="margin-top: 12px; display: flex; justify-content: flex-end">
          <paginationMax50 :pagesize="addTaskPage.pagesize" :currentPage="addTaskPage.currentPage"
            :total="addTaskPage.total" @handleCurrentChange="addTaskPage.handleCurrentChange"
            @handleSizeChange="addTaskPage.handleSizeChange" />
        </div>
        <template #footer>
          <el-button @click="addTaskView = false">关闭</el-button>
        </template>
      </el-dialog>


    </div>
  </div>
</template>

<script>
import { projectbatchAddMaterial, teamsharecheckAccounts, projectaddMaterialLogPage, projectbatchUniProjectList, projectSyncProjectPage, projectSyncUniProject, projectrRetryAddMaterial, projectAddMaterialTaskPage, projectvideoMatchresult, projectvideoMatchsubmit } from '@/request/new/ylyBatch'
import { selectClipLibraryAll } from '@/request/new/videosucai'
import { globalAdConfigcheckAccounts } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch, computed, ref } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件
import paginationMax50 from '@/components/paginationMax50.vue' // 分页（最多50条/页）
import insertViewBatchTrim from '@/components/batch/insertViewBatchTrim.vue' // 媒体账户批量输入组件
import ylySucaiSelector from '@/components/ylyBatch/ylySucaiSelector.vue' // 素材选择器
import { ArrowRight } from '@element-plus/icons-vue'

export default {
  name: 'ylyProjectAddVideo',
  components: { pagination, paginationMax50, insertViewBatchTrim, ylySucaiSelector, ArrowRight },
  setup() {
    const projectTableRef = ref(null)
    const addLogTableRef = ref(null)
    const state = reactive({
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        state.projectUniProjectListFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        state.currentPage = 1
        state.projectUniProjectListFun()
      },
      // 批量项目的传参
      batchAddData: [],
      // 根据商品的选中的视频参数
      selectProductData: [],
      // 批量追加素材弹窗控制
      batchAddView: false,
      // 素材可见性
      videoHpVisibility: 'HIDE_VIDEO_ON_HP',
      // 自动匹配素材数量配置
      maxCount: 200,
      autoMatchCountView: false,
      // 自动匹配素材：loading + 提示文案
      autoMatchLoading: false,
      autoMatchTip: '',
      // 提示文案类型：info(黄) / success(绿) / danger(红)
      autoMatchTipType: 'info',
      // 自动匹配素材轮询句柄与间隔
      autoMatchTimer: null,
      autoMatchPollCount: 0,
      // 素材选择弹窗控制
      sucaiSelectView: false,
      // 追加日志弹窗控制
      addLogView: false,
      // 当前查看日志的任务id（从追加任务点详情进入时携带，之后日志查询都带上）
      addLogTaskId: '',
      // 追加日志筛选
      addLogFilter: {
        advertiserId: '',
        projectId: '',
        projectName: '',
        success: '',
        code: '',
        createTimeRange: [],
        createTimeStart: '',
        createTimeEnd: '',
        type: undefined,
      },
      // 追加日志状态下拉：1成功/0失败，不传查全部
      addLogSuccessOptions: [
        { label: '成功', value: 1 },
        { label: '失败', value: 0 },
      ],
      // 追加日志类型下拉：1=今日素材达到上限
      addLogTypeOptions: [
        { label: '今日素材达到上限', value: 1 },
        { label: '系统（或开发）频控受限', value: 2 }
      ],
      // 追加日志表格
      addLogList: [],
      addLogLoading: false,
      // 追加日志勾选 + 重提loading
      addLogSelected: [],
      addLogRetryLoading: false,
      onAddLogSelectionChange: (val) => {
        state.addLogSelected = val || []
      },
      // 批量重提失败追投：按勾选日志id调用 retryAddMaterial
      retryAddMaterialFun: async () => {
        if (state.addLogSelected.length === 0) {
          return ElMessage({ type: 'warning', message: '请先勾选需要重提的日志' })
        }
        const ids = state.addLogSelected.map((item) => item.id).filter((v) => v != null && v !== '')
        if (ids.length === 0) {
          return ElMessage({ type: 'error', message: '勾选的日志缺少id，无法重提' })
        }
        state.addLogRetryLoading = true
        try {
          const res = await projectrRetryAddMaterial({ ids })
          if (res.code == 200) {
            ElMessage.success('重提任务已提交')
            state.addLogSelected = []
            addLogTableRef.value?.clearSelection()
            state.addLogListFun()
          }
        } finally {
          state.addLogRetryLoading = false
        }
      },
      // 追加日志分页
      addLogPage: {
        pagesize: 50,
        currentPage: 1,
        total: 0,
        handleCurrentChange: (e) => {
          state.addLogPage.currentPage = e
          state.addLogListFun()
        },
        handleSizeChange: (e) => {
          state.addLogPage.pagesize = e
          state.addLogPage.currentPage = 1
          state.addLogListFun()
        },
      },
      // 打开追加日志弹窗：重置到第一页并查询
      openAddLogDialog: () => {
        state.addLogView = true
        state.addLogTaskId = ''
        state.addLogPage.currentPage = 1
        state.addLogSelected = []
        // 默认最近7天（含今天）
        const range = state.getLast7DaysRange()
        state.addLogFilter.createTimeRange = range
        state.addLogFilter.createTimeStart = range[0]
        state.addLogFilter.createTimeEnd = range[1]
        state.addLogListFun()
      },
      // 从追加任务点详情：携带任务id打开追加日志弹窗
      openTaskLogDetailFun: (row) => {
        state.addLogTaskId = row?.id || ''
        state.addLogView = true
        state.addLogPage.currentPage = 1
        state.addLogSelected = []
        const range = state.getLast7DaysRange()
        state.addLogFilter.createTimeRange = range
        state.addLogFilter.createTimeStart = range[0]
        state.addLogFilter.createTimeEnd = range[1]
        state.addLogListFun()
      },
      // 最近7天（含今天），格式 yyyy-MM-dd
      getLast7DaysRange: () => {
        const fmt = (d) => {
          const y = d.getFullYear()
          const m = String(d.getMonth() + 1).padStart(2, '0')
          const day = String(d.getDate()).padStart(2, '0')
          return `${y}-${m}-${day}`
        }
        const end = new Date()
        const start = new Date()
        start.setDate(end.getDate() - 6)
        return [fmt(start), fmt(end)]
      },
      // 同步项目到本地：前端10秒防连点，不判断res.code
      syncLoading: false,
      fullSyncFun: () => {
        if (state.syncLoading) {
          return ElMessage({ type: 'warning', message: '同步中，请10秒后再试' })
        }
        if (!state.config.accountIds || state.config.accountIds.length === 0) {
          return ElMessage({ type: 'error', message: '请先选择媒体账户' })
        }
        state.syncLoading = true
        setTimeout(() => { state.syncLoading = false }, 10000)
        projectSyncUniProject({ advertiserIds: state.config.accountIds })
        // 同步后清除媒体账户
        state.config.accountIds = []
        state.config.accountIdsDesc = ''
        state.config.mediaAccountList = []
        ElMessage.success('同步任务已提交')
      },
      // 合并日期选择器变更：同步 createTimeStart / createTimeEnd
      onAddLogDateRangeChange: (val) => {
        if (val && val.length === 2) {
          state.addLogFilter.createTimeStart = val[0] || ''
          state.addLogFilter.createTimeEnd = val[1] || ''
        } else {
          state.addLogFilter.createTimeStart = ''
          state.addLogFilter.createTimeEnd = ''
        }
      },
      // 追加日志查询：点查询回到第一页
      addLogSearchFun: () => {
        state.addLogPage.currentPage = 1
        state.addLogListFun()
      },
      // 追加日志重置
      resetAddLogFilterFun: () => {
        const range = state.getLast7DaysRange()
        state.addLogFilter = {
          advertiserId: '',
          projectId: '',
          projectName: '',
          success: '',
          code: '',
          createTimeRange: range,
          createTimeStart: range[0],
          createTimeEnd: range[1],
          type: undefined,
        }
        state.addLogPage.currentPage = 1
        state.addLogListFun()
      },
      // 追加日志列表：空值不传，success/code透传
      addLogListFun: async () => {
        state.addLogLoading = true
        try {
          const params = {
            currentPage: state.addLogPage.currentPage,
            size: state.addLogPage.pagesize,
          }
          if (state.addLogTaskId !== '' && state.addLogTaskId != null) params.taskId = state.addLogTaskId
          const f = state.addLogFilter
          if (f.advertiserId !== '' && f.advertiserId != null) params.advertiserId = Number(f.advertiserId)
          if (f.projectId !== '' && f.projectId != null) params.projectId = Number(f.projectId)
          if (f.projectName) params.projectName = f.projectName
          if (f.success !== '' && f.success != null) params.success = f.success
          if (f.code !== '' && f.code != null) params.code = Number(f.code)
          if (f.createTimeStart) params.createTimeStart = f.createTimeStart
          if (f.createTimeEnd) params.createTimeEnd = f.createTimeEnd
          if (f.type !== '' && f.type != null) params.type = f.type
          const res = await projectaddMaterialLogPage(params)
          if (res.code == 200) {
            const data = res.data || {}
            state.addLogList = data.data || data.records || data.list || []
            state.addLogPage.total = data.totalSize || data.total || 0
          }
        } finally {
          state.addLogLoading = false
        }
      },
      // 追加任务弹窗控制
      addTaskView: false,
      // 追加任务筛选
      addTaskFilter: {
        taskName: '',
        status: '',
        createTimeRange: [],
        createTimeStart: '',
        createTimeEnd: '',
      },
      // 追加任务状态下拉
      addTaskStatusOptions: [
        { label: '成功', value: 'SUCCESS' },
        { label: '失败', value: 'FAIL' },
        { label: '执行中', value: 'RUNNING' },
        { label: '待执行', value: 'PENDING' },
      ],
      addTaskStatusLabel: (value) => {
        const hit = state.addTaskStatusOptions.find((item) => item.value === value)
        return hit ? hit.label : (value ?? value === 0 ? value : '-')
      },
      // 追加任务表格
      addTaskList: [],
      addTaskLoading: false,
      // 追加任务分页（最大50条/页）
      addTaskPage: {
        pagesize: 50,
        currentPage: 1,
        total: 0,
        handleCurrentChange: (e) => {
          state.addTaskPage.currentPage = e
          state.addTaskListFun()
        },
        handleSizeChange: (e) => {
          state.addTaskPage.pagesize = e
          state.addTaskPage.currentPage = 1
          state.addTaskListFun()
        },
      },
      // 打开追加任务弹窗：重置到第一页并查询
      openAddTaskDialog: () => {
        state.addTaskView = true
        state.addTaskPage.currentPage = 1
        const range = state.getLast7DaysRange()
        state.addTaskFilter.createTimeRange = range
        state.addTaskFilter.createTimeStart = range[0]
        state.addTaskFilter.createTimeEnd = range[1]
        state.addTaskListFun()
      },
      onAddTaskDateRangeChange: (val) => {
        if (val && val.length === 2) {
          state.addTaskFilter.createTimeStart = val[0] || ''
          state.addTaskFilter.createTimeEnd = val[1] || ''
        } else {
          state.addTaskFilter.createTimeStart = ''
          state.addTaskFilter.createTimeEnd = ''
        }
      },
      addTaskSearchFun: () => {
        state.addTaskPage.currentPage = 1
        state.addTaskListFun()
      },
      resetAddTaskFilterFun: () => {
        const range = state.getLast7DaysRange()
        state.addTaskFilter = {
          taskName: '',
          status: '',
          createTimeRange: range,
          createTimeStart: range[0],
          createTimeEnd: range[1],
        }
        state.addTaskPage.currentPage = 1
        state.addTaskListFun()
      },
      // 追加任务列表：空值不传
      addTaskListFun: async () => {
        state.addTaskLoading = true
        try {
          const params = {
            currentPage: state.addTaskPage.currentPage,
            size: state.addTaskPage.pagesize,
          }
          const f = state.addTaskFilter
          if (f.taskName) params.taskName = f.taskName
          if (f.status !== '' && f.status != null) params.status = f.status
          if (f.createTimeStart) params.createTimeStart = f.createTimeStart
          if (f.createTimeEnd) params.createTimeEnd = f.createTimeEnd
          const res = await projectAddMaterialTaskPage(params)
          if (res.code == 200) {
            const data = res.data || {}
            state.addTaskList = data.data || data.records || data.list || []
            state.addTaskPage.total = data.totalSize || data.total || 0
          }
        } finally {
          state.addTaskLoading = false
        }
      },
      // 当前选素材的商品行
      currentProduct: {},
      // 点击行内选择素材：传入行内账户id+商品名称当素材名称
      openSucaiSelectorFun: (item) => {
        state.currentProduct = item
        state.sucaiSelectView = true
      },
      // 素材选择确定：回写到当前商品行的videos
      confirmSucaiSelectFun: (list) => {
        console.log('素材选择确定：回写到当前商品行的videos', list)
        if (state.currentProduct && state.currentProduct.productId) {
          state.currentProduct.videos = list || []
        }
        state.sucaiSelectView = false
      },
      // 清空该商品行已选素材
      clearProductVideosFun: (item) => {
        if (!item) return
        item.videos = []
        item._expanded = false
      },

      // ==========自动匹配素材==========
      // 打开匹配数量弹窗
      openAutoMatchCountDialog: () => {
        if (state.autoMatchLoading) return
        state.autoMatchCountView = true
      },
      // 确定匹配：校验数量后关闭弹窗并提交匹配任务
      confirmAutoMatchCountFun: () => {
        const count = Number(state.maxCount)
        if (!count || count < 1 || count > 200) {
          return ElMessage({ type: 'warning', message: '素材匹配数量需为1~200之间的整数' })
        }
        state.maxCount = Math.floor(count)
        state.autoMatchCountView = false
        state.autoMatchVideosFun()
      },
      // 组装提交参数：数组中每一项 = { advertiserId, materialName: 商品名称, maxCount }
      buildAutoMatchParams: () => {
        return (state.selectProductData || [])
          .filter((item) => item.advertiserId && item.productName)
          .map((item) => ({
            advertiserId: Number(item.advertiserId),
            materialName: item.productName,
            maxCount: state.maxCount,
          }))
      },
      // 归一化匹配结果中的单个素材：后端返回 fileName（不是 materialName），imageMode 已给全
      normalizeMatchVideo: (item) => {
        let imageMode = item.imageMode ?? item.image_mode ?? null
        if (!imageMode && item.width && item.height) {
          imageMode = Number(item.width) > Number(item.height) ? 'CREATIVE_IMAGE_MODE_VIDEO' : 'CREATIVE_IMAGE_MODE_VIDEO_VERTICAL'
        }
        return {
          materialId: item.materialId ?? item.material_id ?? '',
          materialName: item.materialName ?? item.material_name ?? item.fileName ?? item.file_name ?? '',
          posterUrl: item.posterUrl ?? item.poster_url ?? '',
          videoId: item.videoId ?? item.video_id ?? '',
          imageMode,
          duration: item.duration ?? '',
        }
      },
      // 停止轮询
      stopAutoMatchPolling: () => {
        if (state.autoMatchTimer) {
          clearInterval(state.autoMatchTimer)
          state.autoMatchTimer = null
        }
      },
      // 点击自动匹配素材
      autoMatchVideosFun: async () => {
        if (state.autoMatchLoading) return
        const params = state.buildAutoMatchParams()
        if (params.length === 0) {
          return ElMessage({ type: 'warning', message: '暂无可匹配的商品数据' })
        }
        state.autoMatchLoading = true
        state.autoMatchTipType = 'info'
        state.autoMatchTip = '正在提交匹配任务...'
        try {
          const res = await projectvideoMatchsubmit(params)
          if (res.code == 200) {
            const taskId = res.data?.taskId
            if (!taskId) {
              state.autoMatchLoading = false
              state.autoMatchTipType = 'danger'
              state.autoMatchTip = '匹配任务提交成功，但未获取到taskId'
              return ElMessage.error('匹配任务提交成功，但未获取到taskId')
            }
            state.autoMatchTipType = 'info'
            state.autoMatchTip = '匹配任务已提交，正在等待匹配结果...'
            state.startAutoMatchPolling(taskId)
          } else {
            state.autoMatchLoading = false
            state.autoMatchTipType = 'danger'
            state.autoMatchTip = res.msg || '提交匹配任务失败'
            ElMessage.error(res.msg || '提交匹配任务失败')
          }
        } catch (e) {
          state.autoMatchLoading = false
          state.autoMatchTipType = 'danger'
          state.autoMatchTip = '提交匹配任务失败'
        }
      },
      // 轮询匹配结果：2秒一次，最多60次（约2分钟）；result返回500立即停止轮询
      startAutoMatchPolling: (taskId) => {
        state.stopAutoMatchPolling()
        state.autoMatchPollCount = 0
        const MAX_POLL = 60
        const INTERVAL = 2000
        state.autoMatchTimer = setInterval(async () => {
          state.autoMatchPollCount += 1
          if (state.autoMatchPollCount > MAX_POLL) {
            state.stopAutoMatchPolling()
            state.autoMatchLoading = false
            state.autoMatchTipType = 'danger'
            state.autoMatchTip = '匹配超时，请稍后重试或手动选择素材'
            ElMessage.warning('自动匹配超时，请稍后重试')
            return
          }
          try {
            const res = await projectvideoMatchresult({ taskId })
            // 返回500：任务不存在或已失效，停止轮询
            if (res.code == 500) {
              state.stopAutoMatchPolling()
              state.autoMatchLoading = false
              state.autoMatchTipType = 'danger'
              state.autoMatchTip = res.msg || '匹配结果查询失败，已停止轮询'
              ElMessage.error(res.msg || '匹配结果查询失败，已停止轮询')
              return
            }
            if (res.code == 200) {
              const data = res.data || {}
              const items = data.items || []
              const status = data.status
              // status 为 RUNNING 继续轮询，其他状态（SUCCESS/FAIL等）终止
              if (status === 'RUNNING') {
                state.autoMatchTipType = 'info'
                state.autoMatchTip = `匹配中...（成功${data.successCount ?? 0}，失败${data.failCount ?? 0}，进行中${data.runningCount ?? 0}）`
                return
              }
              if (status) {
                state.applyAutoMatchResult(items)
                state.stopAutoMatchPolling()
                state.autoMatchLoading = false
                const successCount = data.successCount ?? items.filter((it) => it.status === 'SUCCESS').length
                const failCount = data.failCount ?? 0
                const totalVideo = items.reduce((sum, it) => sum + (it.videoCount || 0), 0)
                state.autoMatchTipType = failCount > 0 ? 'danger' : 'success'
                state.autoMatchTip = failCount > 0 ? `匹配完成：成功${successCount}个，失败${failCount}个` : '自动匹配完成'
                if (failCount > 0) {
                  ElMessage.warning(`匹配完成：成功${successCount}个，失败${failCount}个，共匹配${totalVideo}个素材`)
                } else {
                  ElMessage.success(`自动匹配完成，共匹配${totalVideo}个素材`)
                }
              }
            }
          } catch (e) {
            // 单次轮询失败不中断，等下一次
          }
        }, INTERVAL)
      },
      // 回填匹配结果：按 advertiserId + materialName 匹配商品行，写入 videos
      applyAutoMatchResult: (items) => {
        items.forEach((row) => {
          const advertiserId = Number(row.advertiserId ?? row.advertiser_id)
          const materialName = row.materialName ?? row.material_name
          const videos = (row.videos || []).map(state.normalizeMatchVideo)
          const target = (state.selectProductData || []).find(
            (item) => Number(item.advertiserId) === advertiserId && item.productName === materialName,
          )
          if (target && videos.length > 0) {
            // 去重后追加，避免覆盖手动已选的素材
            const existIds = new Set((target.videos || []).map((v) => v.materialId))
            const appendList = videos.filter((v) => !existIds.has(v.materialId))
            target.videos = [...(target.videos || []), ...appendList]
            target._expanded = false
          }
        })
      },

      // 点击批量追加素材：增量合并selectProductData（保留已选videos，新增C、删除B）
      openBatchAddDialog: () => {
        if (state.selectedProjects.length === 0) {
          return ElMessage({ type: 'error', message: '请先勾选项目' })
        }
        // batchAddData: 每次按当前勾选重建，每个选中项目一条
        state.batchAddData = state.selectedProjects.map((item) => ({
          advertiserId: item.advertiserId,
          projectId: item.projectId,
          projectName: item.projectName,
          productId: item.productId,
          videoHpVisibility: 'HIDE_VIDEO_ON_HP',
          videoMaterials: [],
        }))
        // 旧商品缓存：productId -> 旧行（含videos/state/_expanded）
        const oldMap = new Map()
        state.selectProductData.forEach((item) => {
          oldMap.set(item.productId, item)
        })
        // 本次勾选的商品信息：productId -> {productName, advertiserId, projectCount}
        const curMap = new Map()
        state.selectedProjects.forEach((item) => {
          const productId = item.productId
          if (!productId) return
          if (!curMap.has(productId)) {
            curMap.set(productId, {
              advertiserId: item.advertiserId,
              productId,
              productName: item.productName || '',
              projectCount: 1,
            })
          } else {
            curMap.get(productId).projectCount += 1
          }
        })
        // 合并：已存在保留videos/state/_expanded，仅更新名称/数量；新增C追加；取消的B直接丢弃
        const merged = []
        curMap.forEach((cur) => {
          const old = oldMap.get(cur.productId)
          if (old) {
            old.productName = cur.productName || old.productName
            old.projectCount = cur.projectCount
            old.advertiserId = old.advertiserId || cur.advertiserId
            merged.push(old)
          } else {
            merged.push({ ...cur, state: true, videos: [], _expanded: false })
          }
        })
        state.selectProductData = merged
        state.batchAddView = true
      },


      // ==========媒体账户（借鉴 ylyProjectManage.vue）==========
      // 项目状态筛选下拉（项目名称右侧，默认启用中，绑定 config.statusFirst）
      statusFilterOptions: [
        { label: '已删除', value: 'PROJECT_STATUS_DELETE' },
        { label: '未投放', value: 'PROJECT_STATUS_DISABLE' },
        { label: '启用中', value: 'PROJECT_STATUS_ENABLE' },
        { label: '已终止', value: 'PROJECT_STATUS_FROZEN' },
      ],
      // 一级状态下拉（图一）
      statusFirstOptions: [
        { label: '已删除', value: 'PROJECT_STATUS_DELETE' },
        { label: '未投放', value: 'PROJECT_STATUS_DISABLE' },
        { label: '已完成', value: 'PROJECT_STATUS_DONE' },
        { label: '启用中', value: 'PROJECT_STATUS_ENABLE' },
        { label: '已终止', value: 'PROJECT_STATUS_FROZEN' },
      ],
      // 二级状态下拉（图二）
      statusSecondOptions: [
        { label: '未投放-账户头像不可投', value: 'ADVERTISER_AVATAR_OFFLINE' },
        { label: '未投放-审核不通过', value: 'PROJECT_STATUS_OFFLINE_AUDIT' },
        { label: '未投放-重新审核中', value: 'PROJECT_STATUS_AUDIT' },
        { label: '未投放-修改审核中', value: 'PROJECT_STATUS_REAUDIT' },
        { label: '未投放-手动暂停', value: 'PROJECT_STATUS_STOP' },
        { label: '未投放-账户余额不足', value: 'PROJECT_STATUS_ADV_OFFLINE_BUDGET' },
        { label: '未投放-账户超预算', value: 'PROJECT_STATUS_OFFLINE_BUDGET' },
        { label: '未投放-超出预算', value: 'PROJECT_STATUS_BUDGET_EXCEED' },
        { label: '未投放-未达投放时间', value: 'PROJECT_STATUS_NOT_START' },
        { label: '未投放-已达投放时长', value: 'PROJECT_STATUS_REACH_DAILY_DELIVERY' },
        { label: '未投放-投放时间不包含当前时间', value: 'PROJECT_STATUS_NO_SCHEDULE' },
        { label: '未投放-商品不可投放', value: 'PROJECT_STATUS_PRODUCT_OFFLINE' },
        { label: '未投放-关联抖音账号不可投放', value: 'AWEME_ACCOUNT_DISABLED' },
      ],
      // 媒体账户弹窗控制
      mediaAccountView: false,
      // 项目名称弹窗控制
      projectNameView: false,
      // 项目名称textarea文本（换行一行一个）
      projectNameText: '',
      config: {
        // 已选媒体账户列表（展示名称用）
        mediaAccountList: [],
        // 账户批量添加数据的desc（回显用）
        accountIdsDesc: '',
        // 账户ID集合
        accountIds: [],
        // 已选项目名称列表
        projectNameList: [],
        // 项目名称批量输入的desc（回显用）
        projectNameDesc: '',
        // 项目状态筛选，默认启用中
        statusFirst: 'PROJECT_STATUS_ENABLE',
      },
      //获取角色权限编号 
      rId: localStorage.getItem('rId'),
      //获取角色名称 
      loginUserName: localStorage.getItem('userName'),
      // 接收组件的确定自定义账号数据
      getSonAccountListFun: (data) => {
        // 查看账号是否存在
        globalAdConfigcheckAccounts(data.dataList).then((res) => {
          if (res.code == 200) {
            // 管理员不走账户授权校验
            if (state.loginUserName == '黄彬' || state.loginUserName == '任文龙') {
              state.config.accountIds = data.dataList
              state.config.accountIdsDesc = data.desc
              state.config.mediaAccountList = res.data
              state.mediaAccountView = false
            } else {
              teamsharecheckAccounts({ accountIds: data.dataList }).then((res) => {
                if (res.code == 200) {
                  const noAuthList = (res.data || []).filter((item) => !item.allowed)
                  if (noAuthList.length > 0) {
                    const errMsg = noAuthList.map((item) => `组织名称：${item.teamName}<br/>账户名称：${item.accountName}<br/>账户id：${item.accountId}<br/>未授权请找组长授权`).join('<br/><br/>')
                    return ElMessage.error({ dangerouslyUseHTMLString: true, message: errMsg })
                  }
                  state.config.accountIds = data.dataList
                  state.config.accountIdsDesc = data.desc
                  state.config.mediaAccountList = res.data
                  state.mediaAccountView = false
                }
              })
            }
          }
        })
      },
      // 打开项目名称弹窗：回显已选为换行文本
      onProjectNameOpen: () => {
        state.projectNameText = (state.config.projectNameList || []).join('\n')
      },
      // 确定项目名称：textarea按换行解析，一行一个，去空，最多10条
      confirmProjectNameFun: () => {
        const list = String(state.projectNameText || '').split('\n').map((item) => String(item).trim()).filter((item) => !!item)
        if (list.length > 30) {
          ElMessage({ type: 'warning', message: '项目名称最多只能输入30条，已自动截取前30条' })
        }
        state.config.projectNameList = list.slice(0, 30)
        state.config.projectNameDesc = state.config.projectNameList.join('\n')
        state.projectNameText = state.config.projectNameDesc
        state.projectNameView = false
      },
      // 查询项目：先检查账户id，再遍历所有账户id请求接口
      projectList: [],
      searchLoading: false,
      // 表格勾选项
      selectedProjects: [],
      onProjectSelectionChange: (val) => {
        state.selectedProjects = val
      },
      // 点击第一列（勾选列）切换勾选/取消勾选，表头不变
      onProjectRowClick: (row, column) => {
        if (column && column.type === 'selection') {
          projectTableRef.value?.toggleRowSelection(row)
        }
      },
      // 项目状态展示：根据statusFirstOptions映射label+el-result图标+颜色
      statusFirstMeta: (value) => {
        const hit = state.statusFirstOptions.find((item) => item.value === value)
        const label = hit ? hit.label : (value || '-')
        let icon = 'info'
        if (label === '启用中') icon = 'success'
        else if (label === '已删除') icon = 'error'
        else if (label === '已终止' || label === '已停止') icon = 'warning'
        return { label, icon }
      },
      // 点击查询：回到第一页再查
      projectSearchFun: () => {
        state.currentPage = 1
        state.projectUniProjectListFun()
      },
      // 重置：清空媒体账户/项目名称，状态恢复默认启用中
      projectResetFun: () => {
        state.config.accountIds = []
        state.config.accountIdsDesc = ''
        state.config.mediaAccountList = []
        state.config.projectNameList = []
        state.config.projectNameDesc = ''
        state.projectNameText = ''
        state.config.statusFirst = 'PROJECT_STATUS_ENABLE'
        state.currentPage = 1
        state.projectUniProjectListFun()
      },
      projectUniProjectListFun: async () => {        // 本地分页查询：advertiserIds/projectNames 均非必填，有值才传
        state.searchLoading = true
        try {
          const params = {
            currentPage: state.currentPage,
            size: state.pagesize,
          }
          if (state.config.accountIds && state.config.accountIds.length > 0) {
            params.advertiserIds = state.config.accountIds
          }
          const nameList = (state.config.projectNameList || []).map((item) => String(item).trim()).filter((item) => !!item)
          if (nameList.length > 0) {
            params.projectNames = nameList
          }
          if (state.config.statusFirst) {
            params.statusFirst = state.config.statusFirst
          }
          const res = await projectSyncProjectPage(params)
          const data = res?.data || {}
          if (res.code == 200) {
            state.projectList = data.data || []
            state.total = data.totalSize ?? data.total ?? 0
          } else {
            state.projectList = []
          }
        } finally {
          state.searchLoading = false
        }
      },

      // 确定追加：state为true的商品才参与，按productId回填videoMaterials后提交
      confirmBatchAddFun: () => {
        // 商品id -> videos映射（仅state为true）
        const videoMap = new Map()
        state.selectProductData.forEach((item) => {
          if (item.state) {
            videoMap.set(
              item.productId,
              (item.videos || []).map((v) => ({ videoId: v.videoId, imageMode: v.imageMode, materialId: v.materialId, materialName: v.materialName })),
            )
          }
        })
        state.batchAddData.forEach((item) => {
          item.videoMaterials = videoMap.get(item.productId) || []
        })
        const skipped = state.batchAddData.filter((item) => (item.videoMaterials || []).length === 0)
        const submitData = state.batchAddData.filter((item) => (item.videoMaterials || []).length > 0)
        console.log('batchAddData', state.batchAddData)
        console.log('selectProductData', state.selectProductData)
        if (submitData.length === 0) {
          return ElMessage({ type: 'warning', message: '所选商品均未选择素材，已跳过提交' })
        }
        if (skipped.length > 0) {
          ElMessage({ type: 'warning', message: `其中 ${skipped.length} 个项目未选择素材，已跳过` })
        }

        projectbatchAddMaterial(submitData).then((res) => {
          if (res.code == 200) {
            ElMessage.success('添加成功')
            state.batchAddData = []
            state.selectProductData = []
            state.batchAddView = false
            state.selectedProjects = []
            state.projectList = []
          }
        })
      },
    })

    // 已选媒体账户名称拼接（用于省略展示）
    const mediaAccountNames = computed(() => {
      return state.config.mediaAccountList.map((item) => item.name || item.accountName || item.douyinName || item.id).join('、')
    })

    // 已选项目名称拼接（用于省略展示）
    const projectNameNames = computed(() => {
      return (state.config.projectNameList || []).join('、')
    })

    // 项目名称是否非空：非空时页面大小默认150，清空后恢复50
    const hasProjectNames = computed(() => (state.config.projectNameList || []).length > 0)

    // 分页条数选项：项目名称非空时增加150
    const pagesizeOptions = computed(() => (hasProjectNames.value ? [10, 20, 30, 50, 150] : [10, 20, 30, 50]))

    // 项目名称从空变非空 -> pagesize置为150；从非空变空 -> 恢复50，均回到第一页
    // flush: 'sync' 保证重置/清空后立即生效，查询请求读取到的是切换后的pagesize
    watch(
      hasProjectNames,
      (val) => {
        state.pagesize = val ? 150 : 50
        state.currentPage = 1
      },
      { flush: 'sync' },
    )

    // 批量追加素材弹窗关闭时停止自动匹配轮询，避免后台空转
    watch(
      () => state.batchAddView,
      (val) => {
        if (!val) {
          state.stopAutoMatchPolling()
          state.autoMatchLoading = false
          state.autoMatchTip = ''
          state.autoMatchTipType = 'info'
          state.autoMatchCountView = false
        }
      },
    )

    // 进入页面默认调用一次本地分页查询
    state.projectUniProjectListFun()

    // selectClipLibraryAllFun()
    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      projectTableRef,
      addLogTableRef,
      mediaAccountNames,
      projectNameNames,
      pagesizeOptions,
    }
  },
}
</script>

<style lang="scss" scoped>
.page-card {
  border-radius: 10px;
}

.filter-bar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 16px;
  padding: 16px 16px 4px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 10px;
}

.filter-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.filter-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.filter-control {
  width: 200px;
}

.filter-range {
  width: 250px;
}

.filter-account {
  min-width: 0;
}

.filter-account-box {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 220px;
  max-width: 360px;
  height: 32px;
  padding: 0 10px;
  background: #fff;
  border: 1px solid #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  transition: border-color 0.2s, box-shadow 0.2s;

  &:hover {
    border-color: #409eff;
    box-shadow: 0 0 0 1px rgba(64, 158, 255, 0.15);
  }
}

.filter-account-text {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #303133;
}

.filter-empty {
  flex: 1;
  font-size: 13px;
  color: #a8abb2;
  white-space: nowrap;
}

.filter-account-icon {
  color: #a8abb2;
  font-size: 13px;
}

.filter-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.table-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.select-tip {
  font-size: 13px;
  color: #909399;
}

.status-result {
  padding: 0;
}

.status-mini {
  :deep(.el-result__icon svg) {
    width: 24px;
    height: 24px;
  }

  :deep(.el-result__title) {
    margin-top: 2px;
  }

  :deep(.el-result__title p) {
    font-size: 12px;
    line-height: 1.4;
  }
}

.product-name {
  font-size: 13px;
  color: #303133;
}

.product-id {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.batch-add-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.batch-add-toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.batch-add-toolbar-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-shrink: 0;
}

.auto-match-warn {
  font-size: 12px;
  color: #f56c6c;
}

.auto-match-tip {
  font-size: 12px;
  color: #909399;

  &--info {
    color: #e6a23c;
  }

  &--success {
    color: #67c23a;
  }

  &--danger {
    color: #f56c6c;
  }
}

.auto-match-count-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.auto-match-count-label {
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.auto-match-count-unit {
  font-size: 13px;
  color: #909399;
}

.auto-match-count-tip {
  margin-top: 10px;
  font-size: 12px;
  color: #909399;
}

.batch-product-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 16px;
  max-height: 50vh;
  overflow-y: auto;
}

.batch-product-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
}

.batch-product-card {
  padding: 10px 14px;
  background: #f8fafc;
  border: 1px solid #eef2f7;
  border-radius: 8px;
}

.batch-product-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.batch-product-thumbs {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px dashed #e4e7ed;
}

.batch-thumb-wrap {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex-wrap: wrap;

  &.collapsed {
    max-height: 300px;
    overflow: hidden;
  }
}

.batch-thumb-toggle {
  display: flex;
  justify-content: flex-end;
  margin-top: 6px;
}

.batch-thumb {
  width: 92px;
  display: flex;
  flex-direction: column;
  gap: 4px;

  img {
    width: 92px;
    height: 120px;
    object-fit: cover;
    border-radius: 6px;
    border: 1px solid #ebeef5;
    background: #f5f7fa;
    display: block;
  }
}

.batch-thumb-name {
  font-size: 11px;
  color: #909399;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.batch-product-name {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #303133;
}

.batch-product-count {
  font-size: 13px;
  color: #409eff;
  white-space: nowrap;
}

.log-expand {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 4px 8px;
  font-size: 12px;
  line-height: 1.6;
  word-break: break-all;
}

.log-expand-row {
  display: flex;
  gap: 6px;
}

.log-expand-label {
  flex-shrink: 0;
  color: #909399;
}

.log-expand-value {
  color: #303133;
}

.cell-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
